import { render, staticRenderFns } from "./lightbox.vue?vue&type=template&id=544b4164&"
import script from "./lightbox.vue?vue&type=script&lang=js&"
export * from "./lightbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nasa8x/nasa/projects/nodejs/v-lightbox/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('544b4164')) {
      api.createRecord('544b4164', component.options)
    } else {
      api.reload('544b4164', component.options)
    }
    module.hot.accept("./lightbox.vue?vue&type=template&id=544b4164&", function () {
      api.rerender('544b4164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lightbox.vue"
export default component.exports